export const loadTrackingScripts = (consent) => {
    if (!consent) return;

    //  GOOGLE TAG MANAGER 
    if (consent.analytics || consent.marketing) {
        const gtmScript = document.createElement("script");
        gtmScript.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-PZN3P5M');
    `;
        document.head.appendChild(gtmScript);

        // Fallback  (iframe)
        const gtmIframe = document.createElement("iframe");
        gtmIframe.src = "https://www.googletagmanager.com/ns.html?id=GTM-PZN3P5M";
        gtmIframe.height = "0";
        gtmIframe.width = "0";
        gtmIframe.style.display = "none";
        gtmIframe.style.visibility = "hidden";
        document.body.appendChild(gtmIframe);
    }

    //  GOOGLE ADS (gtag) 
    if (consent.analytics || consent.marketing) {
        const gtagScript = document.createElement("script");
        gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=AW-16624227020";
        gtagScript.async = true;
        document.head.appendChild(gtagScript);

        const gtagInit = document.createElement("script");
        gtagInit.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-16624227020');
    `;
        document.head.appendChild(gtagInit);
    }

    //  FACEBOOK PIXEL 
    if (consent.marketing) {
        const fbScript = document.createElement("script");
        fbScript.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '468802296204252');
      fbq('track', 'PageView');
    `;
        document.head.appendChild(fbScript);

        const fbNoscript = document.createElement("noscript");
        fbNoscript.innerHTML = `
      <img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=468802296204252&ev=PageView&noscript=1"/>
    `;
        document.body.appendChild(fbNoscript);
    }
};
